// extracted by mini-css-extract-plugin
module.exports = {"link":"PopoverDefinition_link__QicbK","popover":"PopoverDefinition_popover__cNKF5"};